import { createStructuredSelector } from 'reselect';
import {
  TASK_EMPLOYEE_LIST, TASK_EMPLOYEE_LIST_SUCCESS, TASK_EMPLOYEE_LIST_ERROR,
  TASK_EMPLOYEE_PAGE_SET,
  TASK_EMPLOYEE_ADD, TASK_EMPLOYEE_ADD_SUCCESS, TASK_EMPLOYEE_ADD_ERROR,
  TASK_EMPLOYEE_ADD_CHANGE,
  TASK_EMPLOYEE_DETAIL, TASK_EMPLOYEE_DETAIL_SUCCESS, TASK_EMPLOYEE_DETAIL_ERROR,
  TASK_EMPLOYEE_UPDATE, TASK_EMPLOYEE_UPDATE_SUCCESS, TASK_EMPLOYEE_UPDATE_ERROR,
  TASK_EMPLOYEE_FILTER_EMPLOYEES, TASK_EMPLOYEE_FILTER_EMPLOYEES_SUCCESS,
} from '../../actions';

export const NAME = 'task_employee';

export const TaskEmployeeList = (page, num_page, orderBy, filters) => ({ type: TASK_EMPLOYEE_LIST, payload: { page, num_page, orderBy, filters } });
export const TaskEmployeeListSuccess = (data) => ({ type: TASK_EMPLOYEE_LIST_SUCCESS, payload: data });
export const TaskEmployeeListError = (error) => ({ type: TASK_EMPLOYEE_LIST_ERROR, payload: error });
export const TaskEmployeePageSet = (data) => ({ type: TASK_EMPLOYEE_PAGE_SET, payload: data });
export const TaskEmployeeAddChangeSet = (data) => ({ type: TASK_EMPLOYEE_ADD_CHANGE, payload: data });
export const TaskEmployeeAdd = (data) => ({ type: TASK_EMPLOYEE_ADD, payload: data });
export const TaskEmployeeAddSuccess = (message) => ({ type: TASK_EMPLOYEE_ADD_SUCCESS, payload: message });
export const TaskEmployeeAddError = (error) => ({ type: TASK_EMPLOYEE_ADD_ERROR, payload: error });
export const TaskEmployeeDetail = (data) => ({ type: TASK_EMPLOYEE_DETAIL, payload: data });
export const TaskEmployeeDetailSuccess = (data) => ({ type: TASK_EMPLOYEE_DETAIL_SUCCESS, payload: data });
export const TaskEmployeeDetailError = (error) => ({ type: TASK_EMPLOYEE_DETAIL_ERROR, payload: error });
export const TaskEmployeeUpdate = (data) => ({ type: TASK_EMPLOYEE_UPDATE, payload: data });
export const TaskEmployeeUpdateSuccess = (message) => ({ type: TASK_EMPLOYEE_UPDATE_SUCCESS, payload: message.message });
export const TaskEmployeeUpdateError = (error) => ({ type: TASK_EMPLOYEE_UPDATE_ERROR, payload: error });
export const TaskEmployeeFilterEmployees = (id_supplier) => ({ type: TASK_EMPLOYEE_FILTER_EMPLOYEES, payload: { id_supplier } });
export const TaskEmployeeFilterEmployeesSuccess = (data) => ({ type: TASK_EMPLOYEE_FILTER_EMPLOYEES_SUCCESS, payload: data });

const task_employee = (state) => state[NAME];
export const TaskEmployeeSelector = createStructuredSelector({ task_employee });
